export const BUILD_COMMIT = process.env.REACT_APP_BUILD_COMMIT

export const APP_VERSION = process.env.REACT_APP_VERSION ?? ''

export type DeployedVersion = {
  version: string
  commit: string
  buildTime?: string
}

export async function fetchDeployedVersion(): Promise<DeployedVersion | null> {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
    })
    if (!response.ok) return null
    const data = (await response.json()) as Partial<DeployedVersion>
    if (!data.version || !data.commit) return null
    return {
      version: data.version,
      commit: data.commit,
      buildTime: data.buildTime,
    }
  } catch {
    return null
  }
}

async function clearCaches(): Promise<void> {
  if ('caches' in window) {
    const keys = await caches.keys()
    await Promise.all(keys.map((key) => caches.delete(key)))
  }
  if (navigator.serviceWorker) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(
      registrations.map((registration) => registration.update()),
    )
  }
}

export async function applyUpdate(): Promise<void> {
  await clearCaches().catch(() => undefined)
  window.location.reload()
}
